// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Button Styles */
.btn {
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-transform: none;
  letter-spacing: 0.3px;
  border: none;
  cursor: pointer;
}

.btn-primary {
  background: var(--primary-color);
  color: var(--white);
  box-shadow: var(--shadow-md);
}

.btn-primary:hover {
  background: #0052A3;
  transform: translateY(-1px);
  box-shadow: var(--shadow-lg);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

.btn-secondary {
  background: var(--white);
  color: var(--primary-color);
  border: 2px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.btn-secondary:hover {
  background: var(--light-color);
  border-color: var(--primary-color);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-accent {
  background: var(--accent-color);
  color: var(--white);
  box-shadow: var(--shadow-md);
}

.btn-accent:hover {
  background: #DC2626;
  transform: translateY(-1px);
  box-shadow: var(--shadow-lg);
}

.btn-accent:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

/* Section Headers */
.section-header {
  text-align: center;
  margin-bottom: 64px;
}

.section-subtitle {
  color: var(--primary-color);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 16px;
  display: inline-block;
}

.section-title {
  font-size: 44px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--dark-color);
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.section-description {
  font-size: 18px;
  color: var(--text-light);
  max-width: 680px;
  margin: 0 auto;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 32px;
  }
  
  .section-description {
    font-size: 16px;
  }
  
  .btn {
    padding: 12px 24px;
    font-size: 14px;
  }
}

/* Animation utilities */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.6s ease-out forwards;
}

/* Card styles */
.card {
  background: var(--white);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  border: 1px solid var(--border-color);
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
  border-color: transparent;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Button Styles */\n.btn {\n  padding: 12px 28px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 10px;\n  transition: var(--transition);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-transform: none;\n  letter-spacing: 0.3px;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-primary {\n  background: var(--primary-color);\n  color: var(--white);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-primary:hover {\n  background: #0052A3;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-primary:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-secondary {\n  background: var(--white);\n  color: var(--primary-color);\n  border: 2px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-secondary:hover {\n  background: var(--light-color);\n  border-color: var(--primary-color);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-accent {\n  background: var(--accent-color);\n  color: var(--white);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-accent:hover {\n  background: #DC2626;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-accent:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Section Headers */\n.section-header {\n  text-align: center;\n  margin-bottom: 64px;\n}\n\n.section-subtitle {\n  color: var(--primary-color);\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  margin-bottom: 16px;\n  display: inline-block;\n}\n\n.section-title {\n  font-size: 44px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: var(--dark-color);\n  line-height: 1.2;\n  letter-spacing: -0.5px;\n}\n\n.section-description {\n  font-size: 18px;\n  color: var(--text-light);\n  max-width: 680px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n@media (max-width: 768px) {\n  .section-title {\n    font-size: 32px;\n  }\n  \n  .section-description {\n    font-size: 16px;\n  }\n  \n  .btn {\n    padding: 12px 24px;\n    font-size: 14px;\n  }\n}\n\n/* Animation utilities */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in-up {\n  animation: fadeInUp 0.6s ease-out forwards;\n}\n\n/* Card styles */\n.card {\n  background: var(--white);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  transition: var(--transition);\n  border: 1px solid var(--border-color);\n}\n\n.card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-xl);\n  border-color: transparent;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
